import $i18n, { useI18n } from '@alife/panda-i18n';
import React, { useState, useEffect } from 'react';
import { CnMessage } from '@alife/cn-ui';
import Loading from 'src/view/components/loading';
import { qs } from 'src/utils';
import { logCustom, logError } from 'src/utils/tracker';
import Header from '../header';
import './index.scss';
import { expose } from "@alife/web-rpc";
import { imgPreview } from 'src/utils/dom';
export async function getOnlineUrl({ moziToken, config, lang, urlParam }) {
    let ticket = moziToken;
    if (moziToken) {
        if (typeof moziToken === 'function') {
            try {
                ticket = await moziToken();
            }
            catch (error) {
                console.error(error);
                logError(error, { c2: 'get online service info fail' });
                CnMessage.error($i18n.get({ id: 'FailedToGetOnlineServiceConfigurationInformation', dm: '获取在线服务配置信息失败' }));
                ticket = '';
            }
            if (!ticket) {
                return '';
            }
        }
    }
    let onlineUrl = config?.accessUrl || '';
    if (ticket) {
        onlineUrl += `&moziTicket=${ticket}`;
    }
    try {
        // @ts-ignore   金掌柜CP端 切换cp适配 hack模式  不推荐
        const { cnIntelliAssistantOnlineServiceUrl } = window;
        if (cnIntelliAssistantOnlineServiceUrl) {
            if (typeof cnIntelliAssistantOnlineServiceUrl === 'function') {
                onlineUrl = await cnIntelliAssistantOnlineServiceUrl(onlineUrl, { qs });
                if (typeof onlineUrl !== 'string') {
                    throw new Error('online service url exception');
                }
            }
            else if (typeof cnIntelliAssistantOnlineServiceUrl === 'string') {
                onlineUrl = cnIntelliAssistantOnlineServiceUrl;
            }
            else {
                throw new Error('online service url exception');
            }
        }
    }
    catch (error) {
        logError(error, { c2: 'get online service url fail' });
        console.error(error);
    }
    const hasSearch = onlineUrl.indexOf('?') > -1;
    onlineUrl = `${onlineUrl}${hasSearch ? '&' : '?'}language=${lang}`;
    if (config?.accessStyle !== 'pc') {
        // 添加多语言 加img图片预览功能
        onlineUrl += '&customImagePreview=true';
    }
    // 拼接业务参数
    if (urlParam && Object.keys(urlParam).length) {
        onlineUrl += `&${qs(urlParam)}`;
    }
    return onlineUrl;
}
export default function Online(props) {
    const { onBack, onlineUrl, panelCode } = props;
    const [loading, setLoading] = useState(true);
    const $i18n = useI18n();
    useEffect(() => {
        logCustom('EXP_onlineService', onlineUrl, panelCode);
    }, []);
    useEffect(() => {
        const { close } = expose("xl-im-image-preview", (img) => {
            // console.log(img);
            imgPreview(img);
            return Promise.resolve("ok");
        }, {
            onSendMessage: (msg) => {
                // console.log('111', msg)
            },
        });
        return () => {
            close();
        };
    }, []);
    if (!onlineUrl)
        return null;
    return (React.createElement("div", { className: `cn-ui-intelli-assistant-online` },
        React.createElement(Header, { onClick: onBack, title: $i18n.get({ id: 'OnlineServiceTitle', dm: '在线服务' }) }),
        React.createElement("div", { className: "cn-ui-intelli-assistant-online-content" },
            loading && React.createElement(Loading, { visible: loading }),
            !!onlineUrl && (React.createElement("iframe", { onLoad: () => {
                    setLoading(false);
                }, scrolling: "auto", frameBorder: 0, className: `cn-ui-intelli-assistant-online-iframe ${loading ? 'cn-ui-intelli-assistant-online-iframe-is-loading' : ''}`, title: "xiaoling", name: "xiaoLingIM", id: "ae-xiaoling-im-frame", src: onlineUrl, 
                // src={'https://pre-xl-web.taobao.com/xlPage.html?channel=1000000619&media=true&log=true&customImagePreview=true'}
                onMouseMove: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                } })))));
}
